import runAfterPageLoad from "./runAfterPageLoad";

export default function productForm() {
  runAfterPageLoad(initProductForm);

  function initProductForm() {
    if ($("#product_form").length > 0) {
      initializeUserAttributeFilters("product");
    } else if ($("#hub_page_form").length > 0) {
      initializeUserAttributeFilters("hub_page_form");
    } else if ($("#hero_slider_elements_form").length > 0) {
      initializeUserAttributeFilters("hero_slider_element");
    } else if ($(".user-attribute-filters-search").length > 0) {
      initializeUserAttributeFilters("user_attribute_filters_search");
    }
  }
}

function initializeUserAttributeFilters(modelType) {
  $(`#${modelType}_user_attribute_filters_field_selection`).change(() => {
    const value = $(
      `#${modelType}_user_attribute_filters_field_selection option:selected`
    ).val();
    const exists = document.getElementById(
      `${modelType}_user_attribute_filters_${value}`
    );
    if (!!value && !exists) {
      $("#user_attribute_filters").append(
        modelUserAttributeFilter(modelType, value, "")
      );
      $(`.${modelType}-user-attribute-filters__delete`)
        .last()
        .on("click", { type: modelType }, deleteUserAttributeFilter);
    }
  });

  const filters = $(`#${modelType}_user_attribute_filters_field_selection`).data(
    "filters"
  );

  if (filters) {
    Object.entries(filters).forEach((keyValuePair) => {
      if (!["null", ""].includes(`${keyValuePair[1]}`)) {
        $("#user_attribute_filters").append(
          modelUserAttributeFilter(modelType, keyValuePair[0], keyValuePair[1])
        );
        $(`.${modelType}-user-attribute-filters__delete`)
          .last()
          .on("click", { type: modelType }, deleteUserAttributeFilter);
      }
    });
  }
}

function modelUserAttributeFilter(modelType, name, value) {
  return `<div class="${modelType}-user-attribute-filters__filter">
      <label class="control-label" for="${modelType}_user_attribute_filters_${name}"><small>${name}</small></label>
      <div class="input-group">
        <input class="form-input string optional" name="${modelType}[user_attribute_filters][${name}]" id="${modelType}_user_attribute_filters_${name}" value="${value}">
        <span class="input-group-addon ${modelType}-user-attribute-filters__delete" style="cursor: pointer"><i class="fas fa-trash"></i></span>
      </div>
    </div>`;
}

function deleteUserAttributeFilter(event) {
  const modelType = event.data.type;
  $(event.target).parents(`.${modelType}-user-attribute-filters__filter`).remove();
}
